import { useIntersectionObserver } from 'usehooks-ts';

export const useIsInView = () =>
  useIntersectionObserver({ rootMargin: '100px', freezeOnceVisible: true });
